import { Avatar } from '@mui/material';
import { TimelineIconPlaceholder } from '../../placeholders/timeline-icon.placeholder';
import { TimelineIconProps } from '../timeline.types';
import { useTimelineIconStyles } from './timeline-icon.styles';

export function TimelineIcon({ color, Icon }: TimelineIconProps) {
  const classes = useTimelineIconStyles({ color });
  return (
    <Avatar className={classes.avatar}>
      {Icon ? <Icon className={classes.icon} color={color} /> : <TimelineIconPlaceholder color={color} />}
    </Avatar>
  );
}
